import { Box, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { PoweredByGiphy } from "./../icons";
import styles from "./giphy-selector-scss";
const GiphyErrorState = () => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.giphySelectorErrorContainer }, /* @__PURE__ */ React.createElement(
    Box,
    {
      height: "100%",
      alignContent: "center",
      display: "grid",
      textAlign: "center",
      fontSize: "14px",
      letterSpacing: "1px",
      gap: "12px"
    },
    /* @__PURE__ */ React.createElement(Text, { size: "medium", weight: "bold" }, t("GiphyPlugin_ApiErrorMsg_Title")),
    /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "thin" }, t("GiphyPlugin_ApiErrorMsg_Subtitle"))
  )), /* @__PURE__ */ React.createElement(Box, { display: "block", width: "100%", paddingTop: "8px" }, /* @__PURE__ */ React.createElement(PoweredByGiphy, { className: styles.giphy_selector_powerdByGiphy })));
};
export {
  GiphyErrorState
};
//# sourceMappingURL=giphy-error-state.js.map
